const OTA_UPDATE_CARD = "ota-update-card";
const OTA_RELEASE_NOTES = "ota-release-notes";
const OTA_UPDATE_SUMMARY = "ota-update-summary";
const OTA_FIRMWARE_HISTORY = "ota-firmware-history";
const OTA_CONFIGURATION_HISTORY = "ota-configuration-history";
const OTA_HISTORY_LIST = "ota-history-list";
const OTA_TABLE_HEADER = "ota-table-header";
const OTA_NAVBAR = "ota-navbar";
const OTA = "ota";
const OTA_UPDATE_VIEW = "ota-update-view";
const OTA_MODAL = "ota-modal";
const FIRMWARE_TABS = {
  VERSIONS: "versions",
  BACKUPS: "backups",
} as const;

const CONFIGURATION_TABS = {
  CONFIGURATIONS: "configurations",
  BACKUPS: "backups",
};

const FIRMWARE = "firmware";
const CONFIGURATIONS = "configurations";
const SETTINGS = "settings";
const VERSIONS = "versions";
const BACKUPS = "backups";
const CONFIGURATION_BACKUPS = "configuration-backups";
const ID = "ID";
const IP = "IP";
const CONNECTED = "CONNECTED";
const OTA_FIRMWARE_VERSION_DRAWER_MODAL = "otaFirmwareVersionDrawerModal";
const BACKUP_TYPES = ["FIRMWAREBACKUP", "CONFIGURATIONBACKUP"];
const FIRMWARE_BACKUP_DRAWER_MODAL = "otaFirmwareBackupDrawerModal";
const CONFIGURATION_BACKUP_DRAWER_MODAL = "otaConfigurationBackupDrawerModal";
const INSTALL_AND_ACTION_BLOCK = {
  REQUEST_FOR_APPROVAL: "request_for_approval",
  PENDING_APPROVAL_BY_OPERATOR: "pending_approval_by_operator",
  ACCEPT_AND_PUSH: "accept_and_push",
  REQUEST_APPROVAL_FOR_ADMIN: "request_for_approval_for_admin",
  INSTALLATION_IN_PROGRESS: "installation_in_progress",
  INSTALLATION_FAILED: "installation_failed",
} as const;

enum ActiveInstallationStatus {
  PENDING_APPROVAL = "pending_approval",
  APPROVED = "approved",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  FAILED = "failed",
  DENIED = "denied",
  CANCELLED = "cancelled",
}

enum ProcessTypes {
  FIRMWARE_PUSH = "firmware_push",
  BACKUP_PUSH = "backup_push",
  BACKUP = "backup",
}

export type InstallAndActionBlock =
  (typeof INSTALL_AND_ACTION_BLOCK)[keyof typeof INSTALL_AND_ACTION_BLOCK];

enum OTA_OBJECT_TYPE {
  FIRMWARE = "FIRMWARE",
  CONFIGURATION = "CONFIGURATION",
  FIRMWARE_BACKUP = "FIRMWAREBACKUP",
  CONFIGURATION_BACKUP = "CONFIGURATIONBACKUP",
}

export {
  OTA_RELEASE_NOTES,
  OTA_UPDATE_CARD,
  OTA_UPDATE_SUMMARY,
  OTA_FIRMWARE_HISTORY,
  OTA_HISTORY_LIST,
  OTA_TABLE_HEADER,
  OTA_NAVBAR,
  OTA,
  OTA_MODAL,
  FIRMWARE,
  CONFIGURATIONS,
  SETTINGS,
  FIRMWARE_TABS,
  OTA_CONFIGURATION_HISTORY,
  CONFIGURATION_TABS,
  VERSIONS,
  BACKUPS,
  ID,
  IP,
  CONNECTED,
  OTA_UPDATE_VIEW,
  CONFIGURATION_BACKUPS,
  OTA_FIRMWARE_VERSION_DRAWER_MODAL,
  BACKUP_TYPES,
  FIRMWARE_BACKUP_DRAWER_MODAL,
  CONFIGURATION_BACKUP_DRAWER_MODAL,
  INSTALL_AND_ACTION_BLOCK,
  ActiveInstallationStatus,
  OTA_OBJECT_TYPE,
  ProcessTypes,
};
